// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_rdp","cls2":"AnalyticsV2NavBar-cls2_n-A AnalyticsV2NavBar-cls1_rdp"};